import { Product } from "../types/product";

export function slugify(str: string): string {
  return str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/đ/g, "d")
    .replace(/Đ/g, "D")
    .trim()
    .replace(/\s+/g, "-")
    .replace(/[^a-zA-Z0-9-]/g, "") // bỏ ký tự đặc biệt
    .toLowerCase();
}

export function getGoogleDriveId(url: string): string | '' {
  const match = url.match(/[-\w]{25,}/);
  return match ? match[0] : '';
}


export function getBrandName(products: Product[]): {} {
  let result = []
  // Tạo object để nhóm dữ liệu
  const categoryBrandMap: { [key: string]: Set<string> } = {};
  products.forEach((product) => {
    const category = product.productCategory;
    const brand = product.brandName;

    if (category !== undefined) {
      if (!categoryBrandMap[category]) {
        categoryBrandMap[category] = new Set(); // Dùng Set để tránh trùng lặp
      }
      categoryBrandMap[category].add(brand);
    }
  });

  // Chuyển Set thành Array và tạo mảng kết quả
  result = Object.keys(categoryBrandMap).map((category) => ({
    [category]: Array.from(categoryBrandMap[category]),
  }));
  return result;
}
